import TokenError from "../tokenError";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { Box, Grid2, IconButton, MenuItem, Select, Snackbar, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Label } from "flowbite-react";
import EditableDropdown from './EditableDropdown';

var constants = require('../../constant');

const BookingSettings = () => {

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const navigate = useNavigate();
    const cities = JSON.parse(localStorage.getItem('cities'));
    const [cityFilter, setCityFilter] = useState(cities[0].city_id);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [editable, setEditable] = useState(false);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [rows, setRows] = useState([]);
    const [typeOfMovement, setTypeOfMovement] = useState([]);
    const [containerType, setContainerType] = useState([]);
    const [containerSize, setContainerSize] = useState([]);
    const [truckAvailabilityStatus, setTruckAvailabilityStatus] = useState([]);
    const [inspectionItems, setInspectionItems] = useState([]);


    const fetchBookingSettingsData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/transport/fetch_tms_booking_settings';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag == 200){
                const data = response.data[0]; // ✅ Fix here
                console.log('data', data.booking_fields.type_of_movement);
              
                setRows(response.data);
                setTypeOfMovement(data.booking_fields.type_of_movement || []);
                setContainerType(data.booking_fields.container_type || []);
                setContainerSize(data.booking_fields.container_size || []);
                setTruckAvailabilityStatus(data.truck_head_fields.truck_availabilty_status || []);
                setInspectionItems(data.inspection_fields.inspection_item || []);
              }
              
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(() => {
        fetchBookingSettingsData();
    }, []);

    const handleSubmit = async() =>{
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            booking_fields: {
                "container_size": containerSize,
                "container_type": containerType,
                "type_of_movement": typeOfMovement
            },
            truck_head_fields: {
                "truck_availabilty_status": truckAvailabilityStatus
            },
            inspection_fields: {
                "inspection_item": inspectionItems
            }
        };

        try {
            const url = operationsUrl + '/transport/update_tms_booking_settings';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);
                fetchBookingSettingsData();
            } else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error', error);
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
            Booking Settings
            </Typography>

            <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'8px', padding:'12px', backgroundColor:'#fff', marginTop:'12px'}}>
                <Typography style={{ fontSize: '20px', fontWeight: '500', marginTop:'1%', marginBottom:'2%' }}>
                    Field Manager
                </Typography>

                <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'8px', padding:'16px', backgroundColor:'#fff', marginTop:'12px'}}>
                    <Grid2 sx={{backgroundColor:'#F9F9F9', padding:'12px', borderRadius:'8px'}}>
                        Manager Booking Fields
                    </Grid2>

                    <EditableDropdown
                        label="Type of Movement"
                        options={typeOfMovement}
                        setOptions={setTypeOfMovement}
                        onUpdate={(updatedList) => {
                            setTypeOfMovement(updatedList);
                            const payload = {
                                token: localStorage.getItem('token'),
                                booking_fields: {
                                    container_size: containerSize,
                                    container_type: containerType,
                                    type_of_movement: updatedList
                                },
                                truck_head_fields: {
                                    truck_availabilty_status: truckAvailabilityStatus
                                },
                                inspection_fields: {
                                    inspection_item: inspectionItems
                                }
                            };
                            makePostRequestToUrl(operationsUrl + '/transport/update_tms_booking_settings', payload)
                                .then(response => {
                                    if (response.flag === 200) {
                                        setMessage(response.message);
                                        showSnackbar(true);
                                        fetchBookingSettingsData();
                                    }
                                })
                                .catch(error => {
                                    console.error('Error', error);
                                    setMessage(error);
                                });
                        }}
                    />

                    <EditableDropdown
                        label="Container Type"
                        options={containerType}
                        setOptions={setContainerType}
                        onUpdate={(updatedList) => {
                            setContainerType(updatedList);
                            const payload = {
                                token: localStorage.getItem('token'),
                                booking_fields: {
                                    container_size: containerSize,
                                    container_type: updatedList,
                                    type_of_movement: typeOfMovement
                                },
                                truck_head_fields: {
                                    truck_availabilty_status: truckAvailabilityStatus
                                },
                                inspection_fields: {
                                    inspection_item: inspectionItems
                                }
                            };
                            makePostRequestToUrl(operationsUrl + '/transport/update_tms_booking_settings', payload)
                                .then(response => {
                                    if (response.flag === 200) {
                                        setMessage(response.message);
                                        showSnackbar(true);
                                        fetchBookingSettingsData();
                                    }
                                })
                                .catch(error => {
                                    console.error('Error', error);
                                    setMessage(error);
                                });
                        }}
                    />
                    <EditableDropdown
                        label="Container Size"
                        options={containerSize}
                        setOptions={setContainerSize}
                        onUpdate={(updatedList) => {
                            setContainerSize(updatedList);
                            const payload = {
                                token: localStorage.getItem('token'),
                                booking_fields: {
                                    container_size: updatedList,
                                    container_type: containerType,
                                    type_of_movement: typeOfMovement
                                },
                                truck_head_fields: {
                                    truck_availabilty_status: truckAvailabilityStatus
                                },
                                inspection_fields: {
                                    inspection_item: inspectionItems
                                }
                            };
                            makePostRequestToUrl(operationsUrl + '/transport/update_tms_booking_settings', payload)
                                .then(response => {
                                    if (response.flag === 200) {
                                        setMessage(response.message);
                                        showSnackbar(true);
                                        fetchBookingSettingsData();
                                    }
                                })
                                .catch(error => {
                                    console.error('Error', error);
                                    setMessage(error);
                                });
                        }}
                    />

                </Grid2>

                <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'8px', padding:'16px', backgroundColor:'#fff', marginTop:'12px'}}>
                    <Grid2 sx={{backgroundColor:'#F9F9F9', padding:'12px', borderRadius:'8px'}}>
                        Manager Truck Head Fields
                    </Grid2>

                    <EditableDropdown
                        label="Truck Availability Status"
                        options={truckAvailabilityStatus}
                        setOptions={setTruckAvailabilityStatus}
                        onUpdate={(updatedList) => {
                            setTruckAvailabilityStatus(updatedList);
                            const payload = {
                                token: localStorage.getItem('token'),
                                booking_fields: {
                                    container_size: containerSize,
                                    container_type: containerType,
                                    type_of_movement: typeOfMovement
                                },
                                truck_head_fields: {
                                    truck_availabilty_status: updatedList
                                },
                                inspection_fields: {
                                    inspection_item: inspectionItems
                                }
                            };
                            makePostRequestToUrl(operationsUrl + '/transport/update_tms_booking_settings', payload)
                                .then(response => {
                                    if (response.flag === 200) {
                                        setMessage(response.message);
                                        showSnackbar(true);
                                        fetchBookingSettingsData();
                                    }
                                })
                                .catch(error => {
                                    console.error('Error', error);
                                    setMessage(error);
                                });
                        }}
                    />

                </Grid2>

                <Grid2 sx={{border:'1px solid #D1D5DB', borderRadius:'8px', padding:'16px', backgroundColor:'#fff', marginTop:'12px'}}>
                    <Grid2 sx={{backgroundColor:'#F9F9F9', padding:'12px', borderRadius:'8px'}}>
                        Manager Inspection Fields
                    </Grid2>

                    <EditableDropdown
                        label="Inspection Item"
                        options={inspectionItems}
                        setOptions={setInspectionItems}
                        onUpdate={(updatedList) => {
                            setInspectionItems(updatedList);
                            const payload = {
                                token: localStorage.getItem('token'),
                                booking_fields: {
                                    container_size: containerSize,
                                    container_type: containerType,
                                    type_of_movement: typeOfMovement
                                },
                                truck_head_fields: {
                                    truck_availabilty_status: truckAvailabilityStatus
                                },
                                inspection_fields: {
                                    inspection_item: updatedList
                                }
                            };
                            makePostRequestToUrl(operationsUrl + '/transport/update_tms_booking_settings', payload)
                                .then(response => {
                                    if (response.flag === 200) {
                                        setMessage(response.message);
                                        showSnackbar(true);
                                        fetchBookingSettingsData();
                                    }
                                })
                                .catch(error => {
                                    console.error('Error', error);
                                    setMessage(error);
                                });
                        }}
                    />

                </Grid2>
            </Grid2>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
                     
        </div>
    )
}

export default BookingSettings;